import { render, staticRenderFns } from "./VCalendarView.vue?vue&type=template&id=bf7983ce&"
import script from "./VCalendarView.vue?vue&type=script&lang=js&"
export * from "./VCalendarView.vue?vue&type=script&lang=js&"
import style0 from "./VCalendarView.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf7983ce')) {
      api.createRecord('bf7983ce', component.options)
    } else {
      api.reload('bf7983ce', component.options)
    }
    module.hot.accept("./VCalendarView.vue?vue&type=template&id=bf7983ce&", function () {
      api.rerender('bf7983ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VCalendarView.vue"
export default component.exports